import { GeneralTeacherComponent } from "../../../General/gt.component";
import { InteractiveGraph } from "graph-interactive/dist/lib/interactive/interactiveGraph";
import { Subject } from "rxjs";
import { GraphServiceJson, NameVertex } from "graph-interactive";
import { GeneralExerciseComponent } from "../../../General/g-exercise.component";
import { AbstractNode } from "graph-interactive/dist/lib/abstract/aNode";
import { AbstractEdge } from "graph-interactive/dist/lib/abstract/aEdge";

export abstract class GraphExerciseComponent extends GeneralExerciseComponent {

    protected graphSubject: Subject<InteractiveGraph> = new Subject<InteractiveGraph>();
    protected graph: InteractiveGraph = null;

    ngAfterViewInit(): void {
        this.graph = this.initGraph();
        this.graphSubject.next(this.graph);

        if (this.configuration != null && this.configuration !== undefined) {
            if (this.configuration.typespecifics) {
                GraphServiceJson.importGraph(this.graph, this.configuration);
            }
        }
    }

    /**
     * returns true if @param path is contained in @param collection
     */
    pathContainedInCollection(path: [AbstractNode[], AbstractEdge[]],
        collection: [AbstractNode[], AbstractEdge[]][]): boolean {
        let isIncluded = false;
        collection.forEach(current => {
            let cur_nodes = current[0];
            if (cur_nodes.length == path[0].length) {
                let samePath: boolean = true;
                for (let i = 0; i < cur_nodes.length; i++) {
                    if (cur_nodes[i] != path[0][i]) {
                        samePath = false;
                    }
                }
                if (samePath)
                    isIncluded = true;
            }
        })
        return isIncluded;
    }

    hasVisitedMandatory(path: AbstractNode[], mandatoryNode: AbstractNode[]): boolean {
        let result = true;
        mandatoryNode.forEach(m => {
           
            let visited = false;
            path.forEach(n => {
                if (m == n) {
                
                    visited = true;
                }
            });
            if (visited == false)
                result = false;
        })
        return result;
    }

    importMinimumPath(): number {
        let result = -1;
        if (this.configuration.condition.minPath != undefined) {
            result = Number(this.configuration.condition.minPath);
        }
        return result;
    }

    importPathLength(): number {
        let result = -1;
        if (this.configuration == undefined || this.configuration == null)
            return result;
        if (this.configuration.condition.pathLength != undefined) {
            result = Number(this.configuration.condition.pathLength);
        }
        return result;
    }

    abstract initGraph(): InteractiveGraph;

}